import { FirstMenuArtboard } from "./component/artboard.js";
import { FirstMenuData } from "./component/data.js";
import { FirstMenuDataTransform } from "./component/dataTransform.js";
import { SettingMenuExport } from "./component/export.js";
import { FirstMenuLayout } from "./component/layout.js";
import { SettingMenuPreference } from "./component/preference.js";
import { FirstMenuProjection } from "./component/projection.js";
import { FirstMenuMark, FirstMenuMarkIndividual } from "./component/mark.js";
import { FirstMenuAxis } from "./component/axis.js";
import { FirstMenuLegend } from "./component/legend.js";
import { FirstMenuTitle } from "./component/title.js";
import { FirstMenuAnnotation } from "./component/annotation.js";
import { FirstMenuInteraction } from "./component/interaction.js";
import { FirstMenuSelection } from "./component/selection.js";
import { SettingMenuHistory } from "./component/exploration_history.js";

export let firstLevelMenus = {
  artboard: FirstMenuArtboard,
  data: FirstMenuData,
  data_transformation: FirstMenuDataTransform,
  layout: FirstMenuLayout,
  projection: FirstMenuProjection,
  selection: FirstMenuSelection,
  mark: FirstMenuMark,
  mark_individual: FirstMenuMarkIndividual,
  axis: FirstMenuAxis,
  legend: FirstMenuLegend,
  title: FirstMenuTitle,
  annotation: FirstMenuAnnotation,
  interaction: FirstMenuInteraction,
  preference: SettingMenuPreference,
  exploration_history: SettingMenuHistory,
  export: SettingMenuExport
}

export let firstMenuRoles = ['artboard', 'data', 'data_transformation', 'layout', 'projection', 'selection', 'mark', 'mark_individual', 'axis', 'legend', 'title', 'annotation', 'interaction'];
export let settingRoles = ['preference', 'export', 'preview', 'exploration_history'];